<ng-container *ngIf="fields.fieldType === 'hidden'">
  <!-- HIDDEN FIELD -->
  <div [formGroup]="formGroup">
    <input autoFocus type="hidden" [formControlName]="fields.fieldName" />
  </div>
</ng-container>
<ng-container *ngIf="fields.fieldType != 'hidden'">
  <div [formGroup]="formGroup" class="w-full py-1 px-2">
    <!-- VISIBLE FIELD -->
    <div *ngIf="fields.fieldType !== 'hidden'" class="gap-1 items-start mb-1">
      <!-- ✅ LABEL ABOVE -->
      <div *ngIf="labelAbove; else sideLayout">
        <label
          class="block text-2sm font-medium text-gray-900 dark:text-gray-300 mb-1"
        >
          {{ formatDisplayName(fields.displayName) }}
        </label>

        <div>
          <ng-container *ngTemplateOutlet="inputBlock"></ng-container>
        </div>
      </div>

      <!-- ✅ SIDE LABEL -->
      <ng-template #sideLayout>
        <div
          class="grid grid-cols-12 gap-3 rounded-lg w-full items-center mb-1"
        >
          <!-- LABEL -->
          <div class="col-span-4">
            <label
              class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 whitespace-normal break-words leading-tight"
            >
              {{ formatDisplayName(fields.displayName) }}
            </label>
          </div>

          <!-- INPUT -->
          <div class="col-span-8">
            <ng-container *ngTemplateOutlet="inputBlock"></ng-container>
          </div>
        </div>
      </ng-template>

      <!-- ✅ INPUT BLOCK -->
      <ng-template #inputBlock>
        <span class="text-sm text-gray-500">{{ getDisplayValue(fields?.value) }}</span>
      </ng-template>
    </div>
  </div>
</ng-container>
